import { Switch } from '@/components/ui/switch'
import { Label } from '@/components/ui/label'
import { Card, CardContent } from '@/components/ui/card'

interface ProcessorDryModeFieldProps {
    checked: boolean
    onCheckedChange: (checked: boolean) => void
    disabled?: boolean
}

export const ProcessorDryModeField = ({ checked, onCheckedChange, disabled }: ProcessorDryModeFieldProps) => {
    return (
        <Card>
            <CardContent className="pt-6">
                <div className="flex items-center justify-between">
                    <div className="space-y-0.5">
                        <Label className="text-sm font-medium">Dry Run Mode</Label>
                        <p className="text-xs text-muted-foreground">
                            Intercepts all PSP calls — logs the raw request but never sends it. Transactions are recorded as dry.
                        </p>
                    </div>
                    <Switch
                        checked={checked}
                        onCheckedChange={onCheckedChange}
                        disabled={disabled}
                    />
                </div>
                {checked && (
                    <div className="mt-3 rounded-lg bg-orange-50 p-3 border border-orange-200">
                        <p className="text-sm text-orange-700">
                            Dry run mode is active — no real payments will be processed.
                        </p>
                    </div>
                )}
            </CardContent>
        </Card>
    )
}
